import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { EstadosUsuario } from 'src/app/shared/enums/estados-usuario.enum';
import { UserRoles } from 'src/app/shared/enums/roles-enum';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import {
  leerEstadoCompliance,
  operaComoAprobado,
} from 'src/app/shared/utils/estado-compliance.util';
import Swal from 'sweetalert2';
import { LineaCredito } from '../../interfaces/credit-line.interface';
import { CartolaService } from '../../services/cartola.service';

@Component({
  selector: 'app-remittance',
  templateUrl: './remittance.component.html',
  styleUrls: ['./remittance.component.sass'],
})
export class RemittanceComponent implements OnDestroy, AfterViewInit {
  subscription: Subscription = new Subscription();
  userRole: UserRoles = UserRoles.aguacate_client;
  user: any;
  nombreUsuario: string = '';
  userEnum = UserRoles;
  estadoValidacion: number = -1;
  saldoActual = 0;
  sobregiroDisponible: number | undefined = 0;
  saldoContable: number | undefined = 0;
  lineaCreditoBloqueada: boolean | undefined = false;
  lineaCredito: number | undefined = 0;
  lineaCreditoDisponible = false;
  lineaCreditoData: LineaCredito | undefined;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private cartolaService: CartolaService,
    private actionsService: ActionsService,
    private spinner: SpinnerService
  ) {
    const ref = this.spinner.start();
    this.subscription.add(
      this.store.select('auth').subscribe(({ user, userRole }: any) => {
        this.userRole = userRole;
        this.user = user;
        if (this.userRole === UserRoles.aguacate_client) {
          if (!this.isNotNullOrEmpty(user)) {
            this.estadoValidacion = EstadosUsuario.incompleto;
            return;
          }
          // Mismo campo que el `ActivateGuard` y el home: la relación
          // `estadoCompliance` con la columna plana como respaldo. Leer sólo
          // la relación dejaba a un aprobado en "en validación" — y encima
          // `user.estadoCompliance.estadoID` reventaba si la relación no venía.
          const estadoCompliance = leerEstadoCompliance(user);
          if (
            this.isNotNullOrEmpty(user) &&
            estadoCompliance !== null &&
            [0, 1, 2].includes(estadoCompliance)
          ) {
            this.estadoValidacion = EstadosUsuario.pendienteValidacion;
          }
          // Aprobado (3) o bloqueado (4): opera igual.
          if (this.isNotNullOrEmpty(user) && operaComoAprobado(user)) {
            this.estadoValidacion = EstadosUsuario.validado;
            this.obtenerSaldo();
          }
        }
      })
    );
    this.subscription.add(
      this.actionsService.subjectSaldo.subscribe((res) => {
        if (res === true) {
          this.obtenerSaldo();
        }
      })
    );
    this.spinner.stop(ref);
  }

  isNotNullOrEmpty(object: Object) {
    return object && Object.keys(object).length > 0;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  async obtenerSaldo() {
    if (this.user?.usuarioId) {
      const {
        saldo,
        lineaCreditoId,
        balancePermitido,
        lineaBloqueada,
        sobregiro,
      } = await this.cartolaService.getSaldoCliente(this.user.usuarioId);
      this.saldoActual = saldo;
      this.sobregiroDisponible = sobregiro;
      this.saldoContable = balancePermitido;
      this.lineaCreditoBloqueada = lineaBloqueada;
      this.lineaCredito = lineaCreditoId;
      if (
        this.lineaCredito &&
        this.lineaCredito > 0 &&
        !this.lineaCreditoBloqueada
      ) {
        this.lineaCreditoDisponible = true;
      } else {
        this.lineaCreditoDisponible = false;
      }
    }
  }

  enviarDinero() {
    // Swal.fire({
    //   title: 'Enviar dinero',
    //   text:'Selecciona el tipo de envío',
    //   showDenyButton: true,
    //   showCancelButton: false,
    //   confirmButtonColor: '#1e5a3f',
    //   // denyButtonColor: '#1e5a3f',
    //   confirmButtonText: 'Uno a uno',
    //   // denyButtonText: `Múltiple`,
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     this.router.navigate(['wallet/client/fiat']);
    //   } else if (result.isDenied) {
    //     this.router.navigate(['wallet/client/multiple']);
    //   }
    // });
    Swal.fire({
      title: 'Enviar dinero',
      text: 'Selecciona el tipo de envío',
      showCancelButton: false,
      confirmButtonColor: '#1e5a3f',
      confirmButtonText: 'Uno a uno',
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['wallet/client/fiat']);
      }
    });
  }
}
